<script setup>
const returnFocus = ref(null);

const goToStart = ref(null);
const start = ref(null);
const end = ref(null);
const goToEnd = ref(null);

const { $bus } = useNuxtApp();

const startOver = () => {
    $bus.emit("scroll-lock");
    start.value.focus();
};

const endOver = () => {
    $bus.emit("scroll-unlock");
    end.value.focus();
};

onMounted(() => {
    if (goToStart.value) {
        returnFocus.value = document.activeElement;
        $bus.emit("scroll-lock");
        start.value.focus();
        goToStart.value.addEventListener("focus", startOver);
        goToEnd.value.addEventListener("focus", endOver);
    }
});

onBeforeUnmount(() => {
    if (goToStart.value) {
        $bus.emit("scroll-unlock");
        goToStart.value.removeEventListener("focus", startOver);
        goToEnd.value.removeEventListener("focus", endOver);
        returnFocus.value.focus();
    }
});
</script>

<template>
    <div>
        <div ref="goToStart" tabindex="0" />
        <div ref="start" tabindex="-1" />
        <slot />
        <div ref="end" tabindex="-1" />
        <div ref="goToEnd" tabindex="0" />
    </div>
</template>
